import React from "react"; //, { useContext }
import { Route, Redirect } from "react-router-dom";
//import Page404 from "../pages/Page404/Page404";
//import athenticationService from '../services/Authentications/authenticationService'
import {api} from 'services/ApiFactory/indexOld';

const PrivateRoute = ({ component,render, ...rest }) => {
  const Component=component||render;
  return (
    <Route
      {...rest}
      render={routeProps =>
         api.authentication.isLogin() ? (
          <Component {...routeProps} />
          // <Page404/>
        ) : (
          <Redirect to={{ pathname: '/login', state: { from: routeProps.location } }} />
        )
      }
    />
  );
};


export default PrivateRoute
